import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { accessKeys } from '../../../statics/accessKeys';
import { SELECTED_GOOGLE_ACCOUNT } from '../../../statics/localStorage';
import { accessCheck } from '../../../utils/accessCheck';
import { encryptLocalStorage } from '../../../utils/localStorage.utils';

const GoogleAccountsModal = ({ setSelectedGoogleAccount }) => {
    const [show, setShow] = useState(false);
    const [tableData, setTableData] = useState([]);
    const googleAccount = SELECTED_GOOGLE_ACCOUNT();

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => { setShow(true) };

    async function updateGoogleCredential() {
        let postData = {
            "googleAdsClientId": document.getElementById('google-ad-account-id').value?.trim(),
            "accountName": document.getElementById('google-ad-account-name').value?.trim()
        }
        if (!postData?.googleAdsClientId || !postData?.accountName) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.updateGoogleAdsCredentials);
        loadingHide();
        if (resp.responseCode === 200) {
            getList()
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.getGoogleAccountList);
        loadingHide();
        handleShow();
        if (resp?.responseCode == 200) {
            setTableData(resp?.data);
        } else {
            setTableData([])
        }
    }

    function onSelectAccount(accountData) {
        encryptLocalStorage('google-account', accountData);
        setSelectedGoogleAccount(accountData)
        handleClose()
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '40px', selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.accountName, cell: (row) => (
                <p className="mb-0">{row?.accountName || "--"}</p>
            )
        }, {
            name: "Google Ads Account ID", center: "true", selector: (row) => row?.googleAdsClientId, cell: (row) => (
                <p className="mb-0">{row?.googleAdsClientId ?? "--"}</p>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.status, cell: (row) => (
                <p className={`mb-0 max-line-1 ${row?.status == 1 ? "text-green-600" : row?.status == 2 ? "text-yellow-500" : row?.status == 3 ? "text-purple-600" : row?.status == 4 ? "text-red-600" : ""}`}>{row?.status == 1 ? "Accepted" : row?.status == 2 ? "Pending" : row?.status == 3 ? "Send" : row?.status == 4 ? "Rejected" : ""}</p>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.action, cell: (row) => (
                <button className="mb-0 !border !px-2 !py-1 rounded disabled:border-none disabled:text-gray-500" onClick={() => onSelectAccount(row)} disabled={row?.googleAdsClientId == googleAccount?.googleAdsClientId}>{row?.googleAdsClientId == googleAccount?.googleAdsClientId ? "Selected" : "Select"}</button>
            )
        }]

    return (
        <>
            <button className='mb-0 text-xs font-light text-orange-600 italic !border rounded-lg border-orange-600 !px-3 !py-1 h-max' onClick={() => getList()}>Accounts</button>
            <Modal show={show} onHide={handleClose} size='xl' backdrop="static" >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Your Google Ads Accounts</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='pb-4'>

                        {accessCheck(accessKeys?.setGoogleAdsClientId) && <div className='bg-white px-3 pt-2 pb-3 !mb-4 rounded-lg'>
                            <label htmlFor="" className='text-md font-semibold mb-2.5'>Google Ads Credential</label>
                            <div className="grid grid-cols-1 md:grid-cols-2 !gap-3 mb-1">
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-account-name" className='text-sm  mb-1.5'>Ad Account Name*</label>
                                    <input type="text" id="google-ad-account-name" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Google Ad Account a Name" defaultValue={tableData?.length > 0 ? ("Account-" + (tableData?.length + 1)) : "Account-1"} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-account-id" className='text-sm  mb-1.5'>Google Ads Client ID*</label>
                                    <input type="text" id="google-ad-account-id" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your Google Ad Account ID" />
                                </div>
                            </div>
                            <div className='mb-0 flex justify-end'>
                                <button className='text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full' onClick={() => updateGoogleCredential()}>Add New</button>
                            </div>
                        </div>}

                        <TableComponent
                            columns={columns}
                            data={tableData}
                            isHeader={true}
                            totalRows={tableData?.length}
                            isPagination={false}
                            paginationPerPage={50}
                            handlePageChange={(e) => { }}
                            handlePerRowsChange={(newPerPage, page) => { }} />

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default GoogleAccountsModal